import { ScrollReveal } from "@/components/ScrollReveal";

const proofs = [
  { stat: "~1M", label: "U.S. adults live with MS, about 3 in 4 of them women (National MS Society)" },
  { stat: "~60s", label: "A gentle morning check-in, designed to fit your day" },
  { stat: "30 / 90d", label: "Wellness summaries you can share with your care team" },
  { stat: "Yours", label: "We never sell your data, export or delete any time" },
];

const SocialProof = () => {
  return (
    <section
      className="bg-muted/30 py-20 sm:py-24 border-y border-border"
      aria-labelledby="proof-heading"
    >
      <div className="container mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal>
            <div className="text-center space-y-4 mb-12">
              <h2 id="proof-heading" className="font-display text-2xl sm:text-3xl text-foreground tracking-tight">
                Built for your day. <span className="italic text-primary">not a dashboard.</span>
              </h2>
              <p className="text-muted-foreground max-w-xl mx-auto">
                A quiet wellness companion, not a medical device. What you see are patterns from your own days, kept in plain language.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {proofs.map((p, i) => (
              <ScrollReveal key={p.label} delay={i * 80}>
                <div className="bg-background border border-border rounded-lg p-6 text-center hover:border-primary/30 transition-colors">
                  <div className="font-display text-3xl sm:text-4xl text-primary mb-2">{p.stat}</div>
                  <div className="text-xs sm:text-sm text-muted-foreground leading-relaxed">{p.label}</div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
